<style scoped>
/* .category-card .title {
  margin-bottom: 0;
  margin-top:0;
} */


.category-card .title {
  margin-bottom:0.75rem;
  margin-top:0.5rem;
}
.category-header {
  margin-bottom: 0;
}

.category-header progress {
  height:0.25em;
}

.category-confidence-help {
  width:2%;
}

.category-header .column {
  padding-top:0;
  padding-bottom:0;
}
/* .confidence-score {
    width: 100px;
    margin: none;
} */

/* .confidence-score {
  margin-top:7px;
} */


/* .graph-svg-tip .title {
    color: white!important;
  } */

</style>

<template>

<div class="box category-card">

    <div class="columns is-vcentered category-header">

      <div class="column is-1 category-confidence-help">
        <b-tooltip label="Confidence score">
          <b-icon icon="help-circle-outline" size="is-small" type="is-grey"></b-icon>
        </b-tooltip>
      </div>
        <div class="column is-1 ">

            <progress class="progress is-success is-small category-confidence-score" value="60" max="100">60%</progress>

        </div>
        <div class="column is-8">
            <small class="has-text-grey is-size-7 is-family-monospace"><span class="has-text-weight-bold">{{category.meta_chunks_total_count | numeral('0.a') }}</span> feedbacks for <span class="has-text-weight-bold">{{category.meta_products_total_count}}</span> products</small>
        </div>

        <div class="column is 2">
          <router-link :to="{ name: 'Category', params: { id: category.id }}">
              <b-button size="is-small" type="is-text" icon-left="information-outline" class="is-pulled-right">
                  Explore
              </b-button>
          </router-link>
        </div>
    </div>

    <div class="columns is-gapless">
        <div class="column is-9">
            <h3 class="title is-family-monospace">{{category.name}}</h3>
            <!-- <b-tooltip label="Confidence score"><b-icon icon="help" size="small"></b-icon></b-tooltip> -->


            <small class="has-text-grey is-size-7" v-if="products.length > 0">Notable products</small>

            <b-field grouped group-multiline>
                <div class="control" v-for="product in products" :key="product.id">
                    <router-link :to="{ name: 'Product', params: { id: product.id }}">
                        <b-taglist attached>
                            <!-- <b-tag type="is-dark">{{product.name}}</b-tag> -->
                            <b-tag type="is-grey">{{product.name}}</b-tag>
                            <!-- <b-tag type="is-grey"><small>{{product.meta_chunks_total_count | numeral('0.0a') }}</small></b-tag> -->
                        </b-taglist>
                    </router-link>
                </div>

            </b-field>
        </div>
        <div class="column is-3 is-vcentered is-centered">
            <category-mini-chart :category="category" height="150" />
        </div>
    </div>

</div>

</template>

<script>

import CategoryMiniChart from "@/charts/CategoryMiniChart"

export default {
    name: "CategoryCard",
    props: ["category", ],
    data() {
        return {
            products: [],
        }
    },
    methods: {
        getProducts: function() {
            this.isLoading = true
            this.$http.get(`${this.$root.api_base_url}products/?categories=${this.category.id}&ordering=-meta_chunks_total_count`)
                .then(({
                    data
                }) => {
                    this.data = []
                    data.results.forEach((item) => this.products.push(item))
                })
                .catch((error) => {
                    this.data = []
                    throw error
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
    mounted: function() {
        this.getProducts();
    },
    components: {
        CategoryMiniChart,
    }
}

</script>
